import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  useTheme
} from '@mui/material';

interface CardSectionProps {
  title: string;
  icon?: React.ReactNode;
  iconColor?: 'error' | 'primary' | 'secondary' | 'warning' | 'info' | 'success';
  children: React.ReactNode;
  size?: number;
}

const CardSection: React.FC<CardSectionProps> = ({
  title,
  icon,
  iconColor = 'info',
  children,
  size = 12
}) => {
  const theme = useTheme();

  const iconBgColor = theme.palette.mode === 'dark'
    ? theme.palette[iconColor].dark
    : theme.palette[iconColor].light;

  const iconColorValue = theme.palette[iconColor].main;

  return (
    <Grid item xs={12} md={size} lg={size} sx={{ mb: 0 }}>
      <Card
        elevation={0}
        sx={{

          bgcolor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
          p: 1,

        }}
      >
        <Box mb={2}>
          <Box display="flex" alignItems="center" mb={2}>
            {icon && (
              <Box
                sx={{
                  mr: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: iconBgColor,
                  color: iconColorValue,
                  borderRadius: '50%',
                  width: 32,
                  height: 32,
                }}
              >
                {icon}
              </Box>
            )}
            <Typography 
              variant="subtitle1"
              sx={{ color: theme.palette.text.secondary }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
        <Grid container spacing={0}>
          {children}
        </Grid>
      </Card>
    </Grid>
  );
};

export default CardSection;
